/**
 * NOTE: Jake: 2019-07-18 - WEBUI-2121
 * This is based off of:
 * - '_fnFeatureHtmlFilter' from node_modules/datatables.net/js/jquery.dataTables.js
 * - https://github.com/DataTables/Plugins/blob/master/pagination/input.js
 */
($.fn.dataTable.ext as any).feature.push({
	cFeature: 'G',
	fnInit(oSettings) {
		const label = '<span class="sr-only">Jump to </span>Page:';

		const table = $(oSettings.nTable).DataTable();
		const classes = oSettings.oClasses;
		const tableId = oSettings.sTableId;
		const language = oSettings.oLanguage;
		const previousSearch = oSettings.oPreviousSearch;
		const features = oSettings.aanFeatures;
		const input =
			'<input type="text" class="dataTables_go-to-page_input"/>';

		let str =
			'<span class="dataTables_go-to-page_text">' + label + '</span>';
		str = str.match(/_INPUT_/)
			? str.replace('_INPUT_', input)
			: str + input;

		const filter = $('<div/>', {
			id: !features.f ? tableId + '_go-to-page' : null,
			class: 'dataTables_go-to-page',
		}).append(
			$('<label class="dataTables_go-to-page_label"/>').append(str),
		);

		function jumpToPage(value: string) {
			if (value.trim() === '') {
				// Ignore blank string, reset value back to current page
				jqFilter.val(table.page.info().page + 1);
				return;
			}
			const oldPage = table.page.info().page + 1;
			let page = Number(value);
			if (String(page) !== value) {
				// Reset back if not given a valid number string
				jqFilter.val(table.page.info().page + 1);
				return;
			}
			if (page < 1) {
				page = 1;
			}
			const totalPages = table.page.info().pages;
			if (page > totalPages) {
				// NOTE: Jake: 2019-07-19
				// If over total pages, just cap it.
				// This allows users to type 999/etc to jump
				// to the last page.
				page = totalPages;
			}
			jqFilter.val(page);
			if (oldPage === page) {
				return;
			}
			table.page(page - 1).draw('page');
		}

		function onChange(e: Event): void {
			if (!(e.currentTarget instanceof HTMLInputElement)) {
				return;
			}
			jumpToPage(e.currentTarget.value);
		}

		/**
		 * Restricts input for the given textbox to the given inputFilter.
		 *
		 * @source https://stackoverflow.com/questions/469357/html-text-input-allow-only-numeric-input/469362#469362
		 */
		function setInputFilter(
			textbox: HTMLInputElement | HTMLTextAreaElement,
			inputFilter: (value) => boolean,
		) {
			const inputChangeFn = function () {
				if (inputFilter(this.value)) {
					this.oldValue = this.value;
					this.oldSelectionStart = this.selectionStart;
					this.oldSelectionEnd = this.selectionEnd;
				} else if (this.hasOwnProperty('oldValue')) {
					this.value = this.oldValue;
					this.setSelectionRange(
						this.oldSelectionStart,
						this.oldSelectionEnd,
					);
				}
			};
			for (const type of [
				'input',
				'keydown',
				'keyup',
				'mousedown',
				'mouseup',
				'select',
				'contextmenu',
				'drop',
			]) {
				textbox.addEventListener(type, inputChangeFn);
			}
		}

		function onKeyUp(e: {
			preventDefault: () => void;
			keyCode: number;
			currentTarget: Element;
		}) {
			if (
				e.keyCode === 13 &&
				e.currentTarget instanceof HTMLInputElement
			) {
				e.preventDefault();
				jumpToPage(e.currentTarget.value);
				return;
			}
		}

		const jqFilter = $<HTMLInputElement>('input', filter)
			.on('change.DT', onChange)
			.on('keyup.DT', (e) => onKeyUp(e))
			.attr('aria-controls', tableId)
			.val(table.page.info().page + 1);

		setInputFilter(jqFilter[0], (value): boolean => {
			// Positive integer values only
			return /^\d*$/.test(value);
		});

		table.on('draw', function onDraw(e, settings) {
			// Update page in 'go to page' input if the page changes. Use draw event instead of page event
			// because page event doesn't fire when we set filters (and also in a few other cases).
			jqFilter.val(table.page.info().page + 1);
		});

		return filter[0];
	},
});
